import { Expose } from 'class-transformer';

export class ResolveInvitationResponse {
  email: string;

  @Expose({ name: 'organization_name' })
  organizationName: string;

  @Expose({ name: 'is_valid' })
  isValid: boolean;
}

export class AcceptInvitationRequest {
  @Expose({ name: 'first_name' })
  firstName: string;

  @Expose({ name: 'last_name' })
  lastName: string;
  password: string;

  @Expose({ name: 'password_repeat' })
  passwordRepeat: string;
  token: string;
}

export class AcceptInvitationResponse {
  firstName: string;
  lastName: string;
}
